import { defineStore } from 'pinia';
import { ref } from 'vue';
import api from '@/common/utils/api';
import type { AboutInfo } from '@schema';

type StorageReleaseType = NonNullable<AboutInfo['storage-release']>;

const useVersionsStore = defineStore('versions', () => {
  const serverVersion = ref<StorageReleaseType['version']>();
  const serverRelease = ref<StorageReleaseType['release']>();

  const fetchAbout = async () => {
    const { data } = await api.get<AboutInfo>('/api/v2/about');
    serverVersion.value = data['storage-release']?.version;
    serverRelease.value = data['storage-release']?.release;
    return data;
  };

  return {
    serverVersion,
    serverRelease,
    fetchAbout
  };
});

export default useVersionsStore;
